import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { get, isNil } from 'lodash';
import { isDirty } from 'redux-form';
import { createSelector } from 'reselect';

import {
  activeModalSelector,
  routines as modalRoutines
} from '../../reducers/ui/modal';

import Button from '../../components/shared/Button';

import mapping from './mapping';

import './style.css';

class Modals extends Component {
  static propTypes = {
    className: PropTypes.string
  };
  static defaultProps = {
    className: ''
  };
  state = {
    isLoaded: false,
    isActive: false,
    currentWidth: 600,
    currentBackground: 'rgba(0, 0, 0, 0.75)',
    dialogVisible: false
  };
  componentDidMount() {
    this.timeout = setTimeout(() => {
      if (this.props.activeModal) {
        this.setStyles();
        this.setState({
          isLoaded: true,
          isActive: true
        });
      } else {
        this.setState({
          isLoaded: true
        });
      }
    }, 200);
  }
  componentDidUpdate(prevProps) {
    const { isLoaded } = this.state;
    const { activeModal } = this.props;
    const { activeModal: prevModal } = prevProps;
    if (!isLoaded) return;
    if (isNil(prevModal) && !isNil(activeModal)) {
      this.setStyles();
      this.setState({
        isActive: true
      });
    } else if (isNil(activeModal) && !isNil(prevModal)) {
      this.setState(
        {
          isActive: false
        },
        () => {
          setTimeout(() => {
            this.setStyles();
          }, 200);
        }
      );
    } else if (activeModal !== prevModal) {
      this.setState(
        {
          isActive: false,
          isTransitioning: true
        },
        () => {
          this.timeout = setTimeout(() => {
            this.setStyles();
            this.setState({
              isActive: true,
              isTransitioning: false
            });
          }, 200);
        }
      );
    }
  }
  componentWillUnmount() {
    clearTimeout(this.timeout);
  }
  handleStop = e => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
  };
  handleClose = () => {
    const {
      activeModal: {
        display: { preventAutoClose = false, warnFormName } = {}
      } = {},
      activeFormDirty
    } = this.props;
    const preventAutoCloseValue =
      typeof preventAutoClose === 'function'
        ? preventAutoClose()
        : preventAutoClose;
    if (preventAutoCloseValue) {
      if (activeFormDirty && !isNil(warnFormName)) {
        this.setState({
          dialogVisible: true
        });
      } else if (!activeFormDirty && !isNil(warnFormName)) {
        this.props.closeAllModals();
      }
    } else {
      this.props.closeAllModals();
    }
  };
  handleCancelDialog = e => {
    e.stopPropagation();
    this.setState({
      dialogVisible: false
    });
  };
  handleCloseDialog = e => {
    e.stopPropagation();
    this.setState(
      {
        dialogVisible: false
      },
      () => {
        this.props.closeAllModals();
      }
    );
  };
  setStyles = () => {
    const {
      activeModal: { display: { background, width, height } = {} } = {}
    } = this.props;
    this.setState({
      currentBackground: background || 'rgba(0, 0, 0, 0.75)',
      currentWidth: width || 600,
      currentHeight: height || '80%'
    });
  };
  renderModal() {
    const { activeModal: { name, data = {} } = {} } = this.props;
    const ActiveModal = get(mapping, name, () => (
      <div className="modals-not-found">Modal Not Found</div>
    ));
    return (
      <ActiveModal
        className="modals-modal"
        modalData={data}
        onCancel={this.handleCancel}
        onClose={this.handleClose}
      />
    );
  }
  render() {
    const { className, activeModal } = this.props;
    const {
      isActive,
      isTransitioning,
      isLoaded,
      currentWidth,
      currentHeight,
      currentBackground,
      dialogVisible
    } = this.state;
    const classList = classNames('modals', className, {
      'modals-visible': isActive,
      'modals-transitioning': isTransitioning,
      'modals-loaded': isLoaded
    });
    let overlayStyle = { background: currentBackground };
    let modalStyle = { width: currentWidth, minHeight: currentHeight };
    const modalContainerClassList = classNames('modals-container', {
      'modals-container-inactive': dialogVisible
    });
    const warningClassList = classNames('modals-warning-dialog', {
      'modals-warning-dialog-visible': dialogVisible
    });
    return (
      <div
        className={classList}
        onClick={this.handleClose}
        style={overlayStyle}>
        <div
          className={modalContainerClassList}
          onClick={this.handleStop}
          style={modalStyle}>
          {!isNil(activeModal) && this.renderModal()}
        </div>
        <div className={warningClassList}>
          <div className="modals-warning-dialog-title">Close</div>
          <div className="modals-warning-dialog-message">
            {'Are you sure you want to cancel?'}
          </div>
          <div className="modals-warning-dialog-footer">
            <Button
              label="Yes, Discard"
              primary
              className="modals-warning-dialog-button"
              onClick={this.handleCloseDialog}
            />
            <Button
              label="No"
              className="modals-warning-dialog-button"
              onClick={this.handleCancelDialog}
            />
          </div>
        </div>
      </div>
    );
  }
}

const activeFormNameSelector = createSelector(
  [activeModalSelector],
  (activeModal = {}) => {
    const { display: { warnFormName } = {} } = activeModal;
    return warnFormName;
  }
);

const mapStateToProps = (state, props) => {
  const activeFormName = activeFormNameSelector(state, props);
  return {
    activeModal: activeModalSelector(state, props),
    activeFormDirty: isDirty(activeFormName)(state)
  };
};

const mapDispatchToProps = {
  openModal: modalRoutines.openModal,
  closeModal: modalRoutines.closeModal,
  closeAllModals: modalRoutines.closeAllModals
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Modals);
